export default __webpack_public_path__ + "static/logo_vertical_reversed_mono_lockup-d8e36762c2a4e92a9ed15f452c44c481.svg";